export const formatQuarterlyDate = (value: string): string => {
  const [year, quarter] = value.split('-');
  return `Q${quarter}/${year.slice(-2)}`;
};
